import React from 'react';
import {render} from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { connect } from 'react-redux'

import {cyan400, deepOrange500 } from 'material-ui/styles/colors';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

const styles = {
  container: {
    textAlign: 'center',
  },
  content: {
    paddingTop: '64px'
  }
};

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: cyan400,
    accent1Color: deepOrange500,
  },
});

import TopNav from './TopNav';
import questions from '../questions';
import user from '../user';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

import { Provider } from 'react-redux';

import configureStore from './store'
import initialState from './state.json'
const store = configureStore(initialState)

const rootEl = document.getElementById('root');

const App = ({fullname, email}) => {
  let Child
  Child = email ? questions.components.Questions : user.components.LoginForm
  return (
          <div style={styles.container}>
            <TopNav />
            <div style={styles.content}>
              <Child />
            </div>
          </div>
  )
}

const mapStateToProps = (state) => {
  return {
    fullname: state.user.fullname,
    email: state.user.email,
  }
}

const AppContainer = connect(mapStateToProps)(App)

render(
      <Provider store={store}>
        <MuiThemeProvider muiTheme={muiTheme}>
          <AppContainer />
        </MuiThemeProvider>
      </Provider>
, document.getElementById('app'));





// WEBPACK FOOTER //
// ./src/app/app.js